import { render, staticRenderFns } from "./AddPricelistItem.vue?vue&type=template&id=1921016a"
import script from "./AddPricelistItem.vue?vue&type=script&lang=js"
export * from "./AddPricelistItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports